export default {
  table: {
    day: "日期",
  },
};
